import React from "react";
import { Route, Switch } from "react-router-dom";
import Main from "../screens/Main";
import PrmDetails from "../screens/PrmDetails";
import NavBar from "../components/NavBar";
import PrmUpdate from "../screens/PrmUpdate";
import PrmCreate from "../screens/PrmCreate";
import OperatorDetails from "../screens/OperatorDetails";
import OperatorAssignment from "../screens/OperatorAssignment";
import paths from "./paths";

export default function Routes() {
  return (
    <>
      <NavBar />
      <Switch>
        <Route path={paths.MAIN} exact component={Main} />
        <Route path={paths.PRM_DETAILS} component={PrmDetails} />
        <Route path={paths.PRM_UPDATE} component={PrmUpdate} />
        <Route path={paths.PRM_CREATE} component={PrmCreate} />
        <Route path={paths.OPERATOR_DETAILS} component={OperatorDetails} />
        <Route
          path={paths.OPERATOR_ASSIGNMENT}
          component={OperatorAssignment}
        />
        <Route component={Main} /> {/* Default route */}
      </Switch>
    </>
  );
}
